export default __webpack_public_path__ + "static/media/mobile_top_2.b0992ca0.jpg";